import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import SelectField from '../../fields/SelectField/SelectField';
import AddOnField from '../../fields/AddOnField/AddOnField';
import NumberField from '../../fields/NumberField/NumberField';
import TextButton from '../../../../../elements-buttons/text-button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AddItemFieldSet extends Component {
  constructor (props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange (itemId) {
    this.props.handleItemChange(itemId);
  }

  render () {
    const {
      inventoryOptions,
      currency,
      unitCostBasis,
      itemId,
      editAddOnAction,
      isEditModal
    } = this.props;

    return (
      <div data-testing-id="add-item-field-set">
        <div className="add-item-form-fields">
          <div className="title-section flex space-between column">
            <div className="form-title">
              <FormattedMessage
                id='inbox.add_item_field_set.title'
                defaultMessage='Title'
              />
            </div>
            <Field
              component={SelectField}
              name="title"
              errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_item_field_set.select_item', defaultMessage: 'Please select an item' }) }
              className="form-fields"
              placeholder={ this.props.intl.formatMessage({ id: 'inbox.add_item_field_set.select', defaultMessage: 'Select' }) }
              options={inventoryOptions}
              maxMenuHeight={260}
              attributes={{ 'data-testing-id': 'title-field' }}
              onChange={() => { this.handleChange(itemId); }}
            />
          </div>

          {
            isEditModal &&
            <div>
              <TextButton
                id="edit-inventory-item-button"
                buttonText="Edit inventory item"
                attributes={{
                  'data-testing-id': 'edit-inventory-item-button'
                }}
                onClick={editAddOnAction}
              />
            </div>
          }

          <div className="quantity-section flex space-between column">
            <div className="form-title">
              <FormattedMessage
                id='inbox.add_item_field_set.quantity'
                defaultMessage='Quantity'
              />
            </div>
            <div className="form-fields">
              <div className="flex space-between">
                <div className="flex-col-2">
                  {
                    <Field
                      name="count"
                      className="row-item"
                      component={NumberField}
                      errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_item_field_set.required', defaultMessage: 'Required' }) }
                      attributes={{ 'data-testing-id': 'quantity-field' }}
                    />
                  }
                </div>
                <div className="flex-col-2" />
              </div>
            </div>
          </div>

          <div className="price-section flex space-between column">
            <div className="form-title">
              <FormattedMessage
                id='inbox.add_item_field_set.price'
                defaultMessage='Price'
              />
            </div>
            <div className="form-fields">
              <div className="price-field flex space-between">
                <div className="flex-col-2">
                  <Field
                    name="unit_cost"
                    component={AddOnField}
                    isCurrency
                    label={currency}
                    leftLabel
                    fieldType="number"
                    attributes={{ 'data-testing-id': 'price-field' }}
                  />
                </div>
                <div data-testing-id="unit-cost-basis" className="unit-cost-basis flex-col-2">{unitCostBasis}</div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    );
  }
}

AddItemFieldSet.propTypes = {
  currency: PropTypes.string,
  unitCostBasis: PropTypes.string,
  inventoryOptions: PropTypes.array,
  itemId: PropTypes.string,
  handleItemChange: PropTypes.func,
  editAddOnAction: PropTypes.func,
  intl: intlShape
};

export default injectIntl(AddItemFieldSet);
